import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, DEFAULT_LOCALE } from "@/i18n/translations";

const I18nContext = createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: translations[DEFAULT_LOCALE],
});

export const I18nProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LOCALE;
    const saved = window.localStorage.getItem("m2i_locale");
    if (saved && translations[saved]) return saved;
    // Try browser preference
    const browserLang = (navigator.language || "").toLowerCase();
    if (browserLang.startsWith("sw")) return "sw";
    return DEFAULT_LOCALE;
  });

  const setLocale = (next) => {
    if (!translations[next]) return;
    setLocaleState(next);
    try {
      window.localStorage.setItem("m2i_locale", next);
    } catch (_) {
      /* noop */
    }
  };

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const t = translations[locale] || translations[DEFAULT_LOCALE];

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
